<div class="local-seo-container">
  @if (!isloading) {
    <ng-template #currentNearMeSearch let-current="current">
      <ng-template mat-tab-label>
        <div data-testid="ls-nearme-tab-label">
          '{{ localSEOData.keyword }}'
          <span
            data-testid="ls-nearme-rank"
            class="rank-chip"
            [ngClass]="{
              'top-performer': MainBusinessPerformance === SEOPerformance.TOP,
              'average-performer': MainBusinessPerformance === SEOPerformance.AVERAGE,
            }"
          >
            {{ MainBusinessRank || '-' }}
          </span>
        </div>
      </ng-template>
    </ng-template>

    <ng-container
      *ngTemplateOutlet="currentNearMeSearch; context: { current: currentNearMeSearch$ | async }"
    ></ng-container>

    <ng-container
      *ngTemplateOutlet="
        businessesRanking;
        context: {
          search: currentNearMeSearch$ | async,
          markers: nearMeMarkers,
        }
      "
    ></ng-container>
  } @else {
    <glxy-loading-spinner></glxy-loading-spinner>
  }
</div>

<ng-template #businessesRanking let-search="search" let-markers="markers">
  <div class="row tab-container">
    <div class="col col-md-6 col-xs-12">
      <div class="local-seo-map">
        <google-map
          height="350px"
          width="100%"
          [options]="{
            disableDefaultUI: true,
            disableDoubleClickZoom: true,
            gestureHandling: 'none',
            scrollwheel: false,
            center: { lat: CenterPoint?.latitude, lng: CenterPoint?.longitude },
          }"
          [zoom]="zoomValue"
        >
          <div *ngFor="let marker of markers; let i = index">
            <map-marker
              [position]="{ lat: marker.lat, lng: marker.lng }"
              [icon]="marker.icon"
              [label]="marker.label"
              (mapClick)="onMarkerClick(i)"
            ></map-marker>
          </div>
        </google-map>
      </div>
      <div
        *ngIf="search?.data?.vicinity !== Vicinity.VICINITY_CITY"
        class="map-info-text"
        data-testid="ls-map-info-text"
      >
        <mat-icon>ads_click</mat-icon>
        {{ 'LOCAL_SEO.LOCAL_SEO.MAP_INFO_TEXT' | translate }}
      </div>
    </div>
    <div class="col col-md-6 col-xs-12 ranking-container">
      <div class="radius-in-progress-badge" *ngIf="radiusSetting !== localSEOData.searchRadius">
        <glxy-badge [color]="'grey'" [size]="'normal'">
          {{ 'LOCAL_SEO.LOCAL_SEO.RADIUS_UPDATE_IN_PROGRESS_BADGE' | translate }}
        </glxy-badge>
      </div>
      <div
        *ngIf="search"
        class="description"
        [innerHTML]="
          'LOCAL_SEO.LOCAL_SEO.DESCRIPTION_KEYWORD'
            | translate
              : {
                  searchTerm: search?.keyword,
                  radius: getConvertedRadiusValue(radiusSetting, mapUnits, translatedMapUnitsKMS),
                  unit: mapUnits,
                }
        "
      ></div>
      <ng-container *ngIf="search?.results?.length > 0; else noSearchResults">
        <div data-testid="ls-business-item" *ngFor="let result of search?.results; let index = index; let last = last">
          <div class="row business-item">
            <div class="col">
              <div class="row business table-row">
                <span class="col col-xs-1" data-testid="ls-business-rank">
                  {{ result.rank || '-' }}
                </span>
                <span class="col col-xs-9">
                  <a
                    href="{{ result.url }}"
                    target="_blank"
                    data-testid="ls-business-url"
                    [class.disabled-link]="result.url !== null && result.url !== '' ? null : true"
                  >
                    {{ result.businessName }}
                    <br />
                  </a>
                  <span
                    class="business-review-rating"
                    data-testid="ls-business-review-rating"
                    *ngIf="result.reviews?.rating"
                  >
                    {{ result.reviews?.rating }}
                    <mat-icon class="rating">star</mat-icon>
                  </span>
                  <span
                    class="business-review-count"
                    data-testid="ls-business-review-count"
                    *ngIf="result.reviews?.count > 0"
                  >
                    <span class="divider">•</span>
                    {{ 'LOCAL_SEO.LOCAL_SEO.REVIEWS_COUNT' | translate: { count: result.reviews?.count } }}
                  </span>
                  <span *ngTemplateOutlet="claimStatus; context: { claimStatus: result.claimStatus }"></span>
                </span>
                <span
                  data-testid="ls-main-business"
                  *ngIf="result.isMainBusiness"
                  class="business-chip col col-xs-2"
                  [ngClass]="{
                    'top-performer': businessPerformance(+result.rank) === SEOPerformance.TOP,
                    'average-performer': businessPerformance(+result.rank) === SEOPerformance.AVERAGE,
                  }"
                >
                  {{ 'COMMON.YOU' | translate }}
                </span>
              </div>

              <div class="row table-row">
                <div class="col col-xs-1"></div>
                <span class="col col-xs-9">
                  <span class="business-address" data-testid="ls-business-address">
                    {{ result.address }}
                  </span>
                  <span class="divider">•</span>
                  <span
                    class="business-phone"
                    data-testid="ls-business-phone"
                    *ngIf="result.phoneNumber; else phoneNotFound"
                  >
                    {{ result.phoneNumber | phone: result?.country || 'US' }}
                  </span>
                </span>
              </div>
            </div>
          </div>
          <mat-divider *ngIf="!last" [ngClass]="{ 'last-business': index > 1 }"></mat-divider>
        </div>
        <ng-container *ngIf="search?.mainBusiness === null">
          <mat-divider class="last-business"></mat-divider>
          <div class="row">
            <div class="col col-xs-1"></div>
            <span
              data-testid="ls-business-notfound"
              class="business-not-found"
              [innerHTML]="
                'LOCAL_SEO.LOCAL_SEO.BUSINESS_NOT_FOUND' | translate: { businessName: businessData?.companyName }
              "
            ></span>
          </div>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="localSEOData?.date">
        <div class="updated-date">
          {{ 'COMMON.UPDATED' | translate }} {{ offsetUTC(localSEOData.date) | date: 'MMMM d, y' }}
        </div>
      </ng-container>
    </div>
  </div>

  <ng-template #noSearchResults>
    <div class="no-results-container">
      <glxy-empty-state [size]="'small'" class="empty-state-container">
        <glxy-empty-state-hero>
          <mat-icon>search_off</mat-icon>
        </glxy-empty-state-hero>
        <glxy-empty-state-title>
          {{ 'LOCAL_SEO.LOCAL_SEO.NO_RESULTS_TITLE' | translate }}
        </glxy-empty-state-title>
      </glxy-empty-state>
    </div>
  </ng-template>

  <ng-template #phoneNotFound>
    <span class="business-phone negative">
      {{ 'LOCAL_SEO.LOCAL_SEO.PHONE_NOT_FOUND' | translate }}
    </span>
  </ng-template>

  <ng-template #claimStatus let-claimStatus="claimStatus">
    <ng-container [ngSwitch]="claimStatus">
      <ng-container *ngSwitchCase="GMBClaimStatus.GMB_CLAIM_STATUS_CLAIMED">
        <span class="claim-status" data-testid="ls-claim-status">
          <span class="divider">•</span>
          <mat-icon class="claim-icon positive">verified_user</mat-icon>
          {{ 'LOCAL_SEO.LOCAL_SEO.CLAIMED' | translate }}
        </span>
      </ng-container>

      <ng-container *ngSwitchCase="GMBClaimStatus.GMB_CLAIM_STATUS_UNCLAIMED">
        <span class="claim-status negative" data-testid="ls-claim-status">
          <span class="divider">•</span>
          <mat-icon class="claim-icon material-icons-outlined">not_listed_location</mat-icon>
          {{ 'LOCAL_SEO.LOCAL_SEO.UNCLAIMED' | translate }}
        </span>
      </ng-container>

      <ng-container *ngSwitchDefault>
        <!--don't show anything-->
      </ng-container>
    </ng-container>
  </ng-template>
</ng-template>
